import { apiClient } from '@/shared/api';

import { ArticlesResponse } from '../config';

export async function getArticlesApi(tags?: string[]) {
  const query = new URLSearchParams();
  if (tags?.length) query.set('tags', tags.join(','));
  const response = await apiClient<ArticlesResponse>(
    `articles${query.size ? `?${query}` : ''}`,
  );
  return response.categories;
}
